// extracted by mini-css-extract-plugin
module.exports = {"answers":"Instructions_answers__vE9PW Question_answers__vwJKh"};